import type { ReactNode } from 'react';

/** 텍스트 내 +N.NN% / -N.NN% 패턴을 색상 span 으로 감싸 ReactNode 배열로 반환.
 *  - 양수(+) → .up (빨강)
 *  - 음수(-) → .down (파랑)
 *  globals.css 의 .up/.down 정의를 사용한다. */
export function colorizePercent(text: string | null | undefined): ReactNode[] {
  if (!text) return [];
  const re = /([+\-])(\d+(?:\.\d+)?)%/g;
  const out: ReactNode[] = [];
  let last = 0;
  let m: RegExpExecArray | null;
  let key = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    const sign = m[1];
    const cls = sign === '+' ? 'up' : 'down';
    out.push(
      <span className={cls} key={key++}>
        {sign}
        {m[2]}%
      </span>,
    );
    last = re.lastIndex;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
